<template>
	<div id="content">
		<div class="wrapper">
			<h1>Kontakt</h1>
			<p><b>Ansprechpartner:</b> Mark Purushotham</p>
			<p><b>Telefon: </b><a href="tel:020838547960">0208 / 385 479 60</a> (Mobil: <a href="tel:01722178878">0172 / 217 88 78</a>)</p>
			<p><b>Anschrift:</b> Oberhausener Straße 213, 45476 Mülheim an der Ruhr</p>
			<p><b>Öffnungszeiten:</b> Mo-Do von ca. 9:30 - 13 Uhr sowie immer <b>nach Absprache</b></p>
			<p>Sie können uns jeder Zeit via Email an <b>info@carmarkt.net</b>, per Telefon oder über dieses Kontaktformular erreichen.</p>
			<form id="contact-form" @submit.prevent="submit" v-show="!success">
				<input type="text" name="name" v-model="name" placeholder="Ihr Name" @change.prevent="contentChanged = true" />
				<p v-show="!email.valid" class="error">Bitte geben Sie eine gültige Email-Adresse für Rückfragen an:</p>
				<input type="email" name="email" id="email" placeholder="Ihre Email-Adresse" required :class="{ email , error: !email.valid }" v-model="email.value" @change.prevent="contentChanged = true" @keydown="email.valid = true">
				<input type="text" name="phone" placeholder="Ihre Telefonnummer (optional)" v-model="phone" @change.prevent="contentChanged = true" />
				<p v-show="!message.valid" class="error">Bitte geben Sie eine Nachricht (mind. 20 Zeichen) an:</p>
				<textarea name="message" placeholder="Ihre Nachricht" required v-model="message.text" @change.prevent="contentChanged = true" minlength="20"></textarea>
				<button v-show="!submitting && !success">Senden <i class="fas fa-paper-plane" style="margin-left: 10px;"></i></button>
				<p v-show="submitting">Wird gesendet...</p>
			</form>
			<p v-show="success" class="success">Vielen Dank für Ihre Anfrage! Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen.</p>
			<p v-show="mailError" class="error">Leider sind bei der Kontaktanfrage technische Probleme aufgetreten. Bitte senden Sie eine E-Mail an info@carmarkt.net.<br />Wir entschuldigen uns für die entstandenen Unannehmlichkeiten.</p>
			<p v-show="timeout" class="error">Sie haben bereits vor einigen Minuten eine Anfrage gesendet. Bitte versuchen Sie es in {{ minutesLeft }} Min. erneut.</p>
			<p style="font-size: 8pt; color: #555;">Mit der Benutzung dieses Kontaktformulars akzeptieren Sie unsere <router-link to="/privacy">Datenschutzerklärung</router-link></p>
		</div>
	</div>
</template>

<style lang="scss">
$background-color: #28373B;
// $base-color: #159A19;
$base-color: #B10B16;
$error-color: rgb(143, 27, 27);
#contact-form {
	width: 50%;
	@media(max-width: 600px) {
		width: 100%;
	}
}
input[type="text"], input[type="email"], textarea {
	display: block;
	margin: 3px;
	background: $background-color;
	color: #fff;
	border: 1px solid $background-color;
	padding: 10px 15px;
	width: calc(100% - 6px);
	outline: none;
	box-sizing: border-box;
	border-radius: 0;
	font-family: inherit;

	&.error {
		background: $error-color;
		border: 1px solid $error-color;
	}
}
textarea {
	min-height: 125px;
}
::placeholder {
	color: #ccc;
}
input[type="submit"], button {
	display: block;
	border: 2px solid $background-color;
	background: #fff;
	color: $background-color;
	margin: 3px;
	padding: 10px 15px;
	width: calc(100% - 6px);
	box-sizing: border-box;
	transition: .15s background, .15s color;
	&:hover {
		background: $background-color;
		color: #fff;
	}
}

p {
	&.error {
		color: $error-color;
		font-size: 11pt;
		font-weight: 500;
	}
	&.success {
		display: inline-block;
		background: $background-color;
		color: #fff;
		padding: 10px 15px;
	}
}
</style>


<script>
export default {
	name: 'Contact',
	data: function() {
		return {
			name: "",
			email: {
				value: "",
				valid: true
			},
			phone: "",
			message: {
				text: '',
				valid: true
			},
			submitted: false,
			submitting: false,
			success: false,
			mailError: false,
			timeout: false,
			minutesLeft: 0,
			contentChanged: false
		};
	},
	methods: {
		submit: function() {
			this.submitting = true;
			this.mailError = false;
			this.$http.post(
				'https://carmarkt.net/api/contact-form.php',
				{
					name: this.name,
					email: this.email.value,
					message: this.message.text,
					phone: this.phone
				}
			).then(response => {
				this.submitting = false;
				var json = response.body;
				if (json.status == 'success') {
					this.success = true;
					this.email.valid = true;
					this.message.valid = true;
					this.mailError = false;
					this.contentChanged = false;
				} else if (json.error == 'email') {
					this.email.valid = false;
				} else if (json.error == 'message') {
					this.message.valid = false;
				} else if (json.error == 'timeout') {
					this.timeout = true;
					this.minutesLeft = json.minutesleft;
				} else if (json.error == 'mail_error') {
					this.mailError = true;
				}
			}).catch(() => {
				this.submitting = false;
				this.mailError = true;
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.contentChanged && !confirm('Möchten Sie die Seite verlassen? Ihre Eingaben in dem Kontaktformular gehen hierbei verloren.')) {
			next(false);
		} else {
			next();
		}
	}
}
</script>
